// @flow
import * as orgTypes from 'app/common/constants/schools/types';
import OrgsList from './OrgsList';

export default OrgsList;
export { orgTypes };
